export const TURNSTILE_SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js';

declare global {
  interface Window { turnstile?: unknown }
}

/** Loads the public Turnstile client without blocking the reader bootstrap. */
export function ensureTurnstileScript(): HTMLScriptElement | null {
  if (window.turnstile) return null;

  const existing = document.querySelector<HTMLScriptElement>('script[data-qc-turnstile]');
  if (existing) return existing;

  const script = document.createElement('script');
  script.src = TURNSTILE_SCRIPT_SRC;
  script.async = true;
  script.defer = true;
  script.dataset.qcTurnstile = 'true';
  document.head.appendChild(script);
  return script;
}
